import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../models/config';
import { HttpBaseService } from './http-services/http-base';
import { environment } from 'src/environments/environment';
import { AppService } from '../app.service';
import moment from 'moment';

@Injectable()
export class StorageService {
  apiUrl: string;
  user: string;

  constructor(
    private http: HttpClient,
    private httpService: HttpBaseService,
    private appServcie: AppService,
  ) {
    this.apiUrl = environment.datadropApiUrl;
    this.user = Config.username;
  }

  getIdentity(): string {
    return this.appServcie.readConfig().userINumber + '@verisk.com';
  }

  getList(path: string): Observable<any> {
    return this.httpService.get<any>(`storage/list?path=${path}`);
  }

  downloadList(path: string): Observable<any> {
    return this.httpService.get<any>(`storage/download?path=${path}`);
  }

  createFolder(
    customerId: number,
    sourceSystemId: number,
    productId: number,
    lobId: number,
    folderDetails: {
      folderName: string;
      filenamePattern?: string;
      numOfFiles?: number;
      fileType?: string;
    },
  ): Observable<any> {
    let request = {
      customerId: customerId,
      sourceSystemId: sourceSystemId,
      productId: productId,
      lobId: lobId,
      folderName: folderDetails.folderName,
      filenamePattern: folderDetails.filenamePattern,
      numOfFiles: folderDetails.numOfFiles,
      fileType: folderDetails.fileType,
    };
    return this.httpService.create<any>('storage/folder', request);
  }

  getScope(
    customerId: number,
    sourceSystemId: number,
    productId: number,
    lobId: number,
  ): Observable<any> {
    let params = new HttpParams()
      .set('customerId', customerId.toString())
      .set('sourceSystemId', sourceSystemId.toString())
      .set('productId', productId.toString())
      .set('lobId', lobId.toString());
    return this.httpService.get<any>('scopes', params);
  }

  getUploadLink(
    scopeId: number,
    folderName: string,
    fileName: string,
    uploadTimeLocal?: Date,
    convertedFrom?: string,
  ): Observable<any> {
    const uploadTime =
      moment(uploadTimeLocal).format('MM/DD/YYYY HH:mm:ss') ??
      moment().format('MM/DD/YYYY HH:mm:ss');
    console.log('uploadTime: ', uploadTime);

    let params = new HttpParams()
      .set('scopeId', scopeId.toString())
      .set('folderName', folderName)
      .set('fileName', fileName)
      .set('uploadTime', uploadTime);

    if (convertedFrom !== undefined) {
      params = params.set('convertedFrom', convertedFrom);
    }

    // Use httpService which adds Okta authentication headers
    return this.httpService.get<string>('storage/uploadlink', params);
  }

  uploadFile(uploadLink: string, file: File) {
    if (!file) {
      throw new Error('File is required for upload');
    }

    const kmsKeyId = this.appServcie.readConfig().kmsKeyId;
    const headers = new HttpHeaders()
      .set('Content-Type', file.type || 'application/octet-stream')
      .set('x-amz-server-side-encryption', 'aws:kms')
      .set('x-amz-server-side-encryption-aws-kms-key-id', kmsKeyId);

    return this.http.put(uploadLink, file, {
      headers: headers,
      reportProgress: true,
      observe: 'events',
    });
  }

  deleteFileQueueId(id: string): Observable<any> {
    return this.httpService.delete<any>(`queue/${id}`);
  }
}
